import React from "react";

export default function SkeletonLoader({ text }) {
  return (
    <div className="text-center text-white text-lg animate-pulse">{text}</div>
  );
}
